/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetIdentityProviderConnectionSetupMethodRequestBody,
  SetIdentityProviderConnectionSetupMethodRequestBody$Outbound,
  SetIdentityProviderConnectionSetupMethodRequestBody$outboundSchema,
} from "../components/setidentityproviderconnectionsetupmethodrequestbody.js";

export type SetIdentityProviderConnectionSetupMethodSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type SetIdentityProviderConnectionSetupMethodRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  setIdentityProviderConnectionSetupMethodRequestBody:
    SetIdentityProviderConnectionSetupMethodRequestBody;
};

/** @internal */
export type SetIdentityProviderConnectionSetupMethodSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SetIdentityProviderConnectionSetupMethodSecurity$outboundSchema:
  z.ZodMiniType<
    SetIdentityProviderConnectionSetupMethodSecurity$Outbound,
    SetIdentityProviderConnectionSetupMethodSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function setIdentityProviderConnectionSetupMethodSecurityToJSON(
  setIdentityProviderConnectionSetupMethodSecurity:
    SetIdentityProviderConnectionSetupMethodSecurity,
): string {
  return JSON.stringify(
    SetIdentityProviderConnectionSetupMethodSecurity$outboundSchema.parse(
      setIdentityProviderConnectionSetupMethodSecurity,
    ),
  );
}

/** @internal */
export type SetIdentityProviderConnectionSetupMethodRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  SetIdentityProviderConnectionSetupMethodRequestBody:
    SetIdentityProviderConnectionSetupMethodRequestBody$Outbound;
};

/** @internal */
export const SetIdentityProviderConnectionSetupMethodRequest$outboundSchema:
  z.ZodMiniType<
    SetIdentityProviderConnectionSetupMethodRequest$Outbound,
    SetIdentityProviderConnectionSetupMethodRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      setIdentityProviderConnectionSetupMethodRequestBody:
        SetIdentityProviderConnectionSetupMethodRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        setIdentityProviderConnectionSetupMethodRequestBody:
          "SetIdentityProviderConnectionSetupMethodRequestBody",
      });
    }),
  );

export function setIdentityProviderConnectionSetupMethodRequestToJSON(
  setIdentityProviderConnectionSetupMethodRequest:
    SetIdentityProviderConnectionSetupMethodRequest,
): string {
  return JSON.stringify(
    SetIdentityProviderConnectionSetupMethodRequest$outboundSchema.parse(
      setIdentityProviderConnectionSetupMethodRequest,
    ),
  );
}
